<template>
  <div class="page-title">
    <h2 :class="headerClass" v-if="!isMobileDevice">
      <div class="lds-ripple-survey align-middle" v-bind:class="{ invisible: !isDataLoading }">
        <div></div>
        <div></div>
      </div>

      <i :class="this.$props.iconClasses"></i>
      &nbsp;
      {{ title }}
      <button
        type="button"
        v-if="canDownload && subtitle == null"
        class="btn btn-chart ml-3"
        v-on:click="$emit('onButtonClick')"
        v-tooltip="{ content: tooltipLabel, placement: 'top-center' }"
      >
        <i class="fas fa-download"></i>
      </button>
      <button
        v-if="hasModal && subtitle == null"
        type="button"
        class="btn btn-chart ml-3"
        data-toggle="modal"
        :data-target="modalId"
        v-on:click="$emit('onButtonClick')"
        v-tooltip="{ content: $t('site.add'), placement: 'top-center' }"
      >
        <i class="fas fa-plus"></i>
      </button>

      <h5>
        {{ subtitle }}
        <button
          type="button"
          v-if="canDownload && subtitle != null"
          class="btn btn-chart ml-3"
          v-on:click="$emit('onButtonClick')"
          v-tooltip="{ content: tooltipLabel, placement: 'top-center' }"
        >
          <i class="fas fa-download"></i>
        </button>

        <button
          v-if="hasModal && subtitle != null"
          type="button"
          class="btn btn-chart ml-3"
          data-toggle="modal"
          :data-target="modalId"
          v-on:click="$emit('onButtonClick')"
          v-tooltip="{ content: $t('site.add'), placement: 'top-center' }"
        >
          <i class="fas fa-plus"></i>
        </button>
      </h5>
    </h2>

    <h2
      :class="headerClass"
      v-if="isMobileDevice"
      :style="
        isSmartphoneDevice && isMediumScreen && isTimelineDisplayed ? 'margin-top: 4.5rem;' : ''
      "
    >
      <i :class="this.$props.iconClasses" v-if="this.$props.iconClasses">&nbsp;</i>
      {{ title }}
      <button
        type="button"
        class="btn btn-chart ml-3"
        v-on:click="$emit('onButtonClick')"
        v-if="canDownload"
        v-tooltip="{ content: tooltipLabel, placement: 'top-center' }"
      >
        <i class="fas fa-download"></i>
      </button>

      <div class="lds-ripple-survey align-middle" v-if="isDataLoading">
        <div></div>
        <div></div>
      </div>
    </h2>
  </div>
</template>

<script>
import { utilsMixin } from '../../utils/mixins'

export default {
  name: 'PageTitle',
  mixins: [utilsMixin],
  props: {
    isDataLoading: Boolean,
    title: String,
    canDownload: Boolean,
    iconClasses: String,
    subtitle: String,
    isSmartphone: Boolean,
    isTimelineDisplayed: Boolean,
    tooltipLabel: String,
    modalId: String,
    hasModal: Boolean,
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  computed: {
    headerClass: function() {
      if (this.isSmartphoneDevice || this.isSmallScreen) {
        return this.isTimelineDisplayed
          ? 'header-title dashboard-title title-font'
          : 'header-title title-font'
      } else {
        return this.isTimelineDisplayed
          ? 'header-title dashboard-title title-font'
          : 'header-title title-font'
      }
    },
  },
}
</script>
